/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFileStatsQueryResponse, IngestionStatusControllerGetFileStatsQueryParams, IngestionStatusControllerGetFileStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFileStats";

function getIngestionStatusControllerGetFileStatsUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/files` as const }  
  return res
}

/**
 * @description Returns statistics about file uploads and processing, including counts by status, success rates, and time series data. Requires System Administrator role.
 * @summary Get file ingestion statistics
 * {@link /api/v1/documents/ingestion-status/files}
 */
export async function ingestionStatusControllerGetFileStats(params?: IngestionStatusControllerGetFileStatsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetFileStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileStats403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetFileStatsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}